import { Injectable, EventEmitter } from '@angular/core';
import { Notification } from '../_models/notification.class';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private subject = new Subject<any>();
  constructor() { }
  notify(type: string, content?: string, icon?: string, time: number = 4000) {
    //this.subject.next({ type, content, icon });
    // Create the container div
    const div = document.createElement('div');
    div.style.position = 'fixed';
    div.style.top = '20px';
    div.style.right = '20px';
    div.style.zIndex = '9999';
    div.style.padding = '12px 20px';
    div.style.borderRadius = '4px';
    div.style.backgroundColor = this.getBackgroundColor(type);
    div.style.color = '#fff';
    div.style.boxShadow = '0 2px 6px rgba(0,0,0,0.3)';
    div.style.display = 'flex';
    div.style.alignItems = 'center';
    div.style.gap = '15px';

    // Add icon if exists
    if (icon) {
      const iconElem = document.createElement('i');
      iconElem.className = icon;
      div.appendChild(iconElem);
    }

    // Add text
    const text = document.createElement('span');
    text.textContent = content || '';
    div.appendChild(text);


    // Create circular timer container
    const timerContainer = document.createElement('div');
    timerContainer.style.width = '40px';
    timerContainer.style.height = '40px';
    timerContainer.style.borderRadius = '50%';
    timerContainer.style.border = '3px solid #fff';
    timerContainer.style.display = 'flex';
    timerContainer.style.justifyContent = 'center';
    timerContainer.style.alignItems = 'center';
    timerContainer.style.fontWeight = 'bold';
    timerContainer.style.fontSize = '14px';
    timerContainer.style.position = 'relative';

    // Add countdown number inside circle
    const timerText = document.createElement('span');
    let seconds = Math.ceil(time / 1000);
    timerText.textContent = seconds.toString();
    timerContainer.appendChild(timerText);
    div.appendChild(timerContainer);

    // Add close (×) button
    const closeBtn = document.createElement('button');
    closeBtn.textContent = '×';
    closeBtn.style.marginLeft = '12px';
    closeBtn.style.border = 'none';
    closeBtn.style.background = 'transparent';
    closeBtn.style.color = '#fff';
    closeBtn.style.fontSize = '20px';
    closeBtn.style.cursor = 'pointer';
    closeBtn.onclick = () => {
      clearInterval(countdownInterval);
      div.remove();
    };
    div.appendChild(closeBtn);

    // Append to body
    document.body.appendChild(div);

    // Optional: Auto remove after 5 seconds
    //setTimeout(() => div.remove(), time);
    // Start countdown
    const countdownInterval = setInterval(() => {
      seconds--;
      if (seconds > 0) {
        timerText.textContent = seconds.toString();
      } else {
        clearInterval(countdownInterval);
        div.remove();
      }
    }, 1000);
  }
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

  notifyDisableEmployee(type: string, content?: string, icon?: string) {
    this.subject.next({ type, content, icon });
  }

  private getBackgroundColor(type: string): string {
    switch (type) {
      case 'success': return '#28a745';
      case 'error': return '#dc3545';
      case 'danger': return '#dc3545';
      case 'warning': return '#ffc107';
      case 'info': return '#17a2b8';
      default: return '#333';
    }
  }
}
